import { Edit, SimpleForm, TextInput, required, NumberInput } from 'react-admin';

export const FailureCauseEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <SimpleForm>
      <NumberInput source="id" disabled />
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="description" multiline rows={3} fullWidth />
    </SimpleForm>
  </Edit>
);
